/* eslint-disable @typescript-eslint/no-unused-vars */
import SkuPages from '@/components/sku/SkuPages';
import { getSkuServerSideProps } from '@/lib/serverSideProps/serverSidePropsPages/getSlugPageServerSideProps';
import { SkuPageProps } from '@/types/props/pages';
import { GetServerSideProps } from 'next';

export default function SlugPage(props: SkuPageProps) {
  return <SkuPages {...props} />;
}
export const getServerSideProps: GetServerSideProps = getSkuServerSideProps;
